import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import NotificationSystem from 'react-notification-system';
import Cookies from 'universal-cookie';
import { get, post, patch, postWithHeaders, putWithHeadersResponse } from "../../../server/actions";
import { MONTH, currency_symbol, date_format, partnerSchoolList, PARTNER_PAYMENT_URL, allergens } from '../../../server/constants';
import Modal from 'react-modal'
import moment from "moment/moment";
import EventSlider from '../eventSlider/EventSlider'
import {
    _addNotificationError,
    getOrderMonthYearByStudent,
    allowNumericWithdecimal,
    _addNotification,
    _addNotificationWarning,
    getGradeNumberByText,
    getModuleEnum,
    getAccessLevelByModule,
    allowNumberWithDecimalNegative,
    gradeTextToNumber,
    isRegularLunchOrderType, getSchoolGrades, groupBy, convertTwoDecimalPoint
} from "../../../server/util";
import DemoVideos from './demoVideos';
import AllergensModel from './AllergensModel';
import CustomSubmit from '../../Misc/customSubmit';

var _ = require('lodash');
const defaultImg = require('../../../assets/img/student-icon.png')
let updated = [];

const modalStyles = {
    content: {
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '50%',
        transform: 'translate(-50%, -30%)',
        overflow: 'initial'
    }
};

const styles = {
    fullWidth: {
        width: "100%"
    },
    btnStyle: {
        borderRadius: "25px",
        width: "100%",
        margin: "8px 0px"
    },
    imageStyle: {
        height: '20px',
        width: '20px',
    },
    eggImageStyle: {
        height: '20px',
        width: '12px',
    },
    fishImageStyle: {
        height: '12px',
        width: '20px',
    },
    fishStyle: {

        display: "flex", alignItems: "center", padding: '9px 6px', borderRadius: "50%", border: "none !important"
    },
    allergensButtonStyle: {
        display: "flex", alignItems: "center", padding: '5px 5px', borderRadius: "50%", border: "none !important"
    },
    eggButtonStyle: {
        display: "flex", alignItems: "center", padding: '5px 9px', borderRadius: "50%", border: "none !important"
    },
    itemStyle: {
        display: "flex",
        flexDirection: "column",
        margin: "0px",
        padding: "0px",
        alignItems: "center",
    }
}

const schoolContactStyles = {
    content: {
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '25%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};

function compare(a, b) {
    if (a.firstName < b.firstName)
        return -1;
    if (a.firstName > b.firstName)
        return 1;
    return 0;
}

const modEnum = getModuleEnum();
class parentDashboard extends Component {

    constructor(props) {
        super(props);
        //this.cookies = new Cookies();
        // this.Auth = new AuthService();
        this.state = {
            modalIsOpen: false,
            schoolContactModalIsOpen: false,
            showAllergies: false,
            orderStatus: '',
            studentData: [],
            loading: false,
            userName: "",
            logInUserRole: "",
            login_user: "",
            cookies: new Cookies(),
            isCookie: false,
            studentsList: [],
            allergensOpen: {},
            spendLimitAmount: '',
            schoolInfo: {},
            survey: {
                id: 0,
                householdSize: 0,
                income: 0.00,
                incomeType: 1,
                loggedUser: sessionStorage.getItem('loggedInUserInfo'),
                parentEmail: sessionStorage.getItem('loggedInUserInfo')
            },
            payModalObject: {
                mealSchoolId: 0,
                transactionType: '',
                transactionDescription: '',
                checkNumb: '',
                totalTransactionAmount: 0.00,
                studentWiseTransactions: [] //{ "studentRecId":375,"name":"","balAmt":0.00,"transactionAmount":200},                    
            },
            payTransferModalObject: {
                mealSchoolId: 0,
                transactionDescription: '',
                totalTransactionAmount: 0.00,
                studentWiseTransactions: []
            },
            allergies: {},
            existingValues: {},
            transferModalIsOpen: false,
            transferBalStudents: [],
            selectedStudent: {},
            selectTransStudent: {},
            studentCountryCode: ""
        }
        // this.getStudentExtraInfo = this.getStudentExtraInfo.bind(this);
        // this.getSurveyDetails = this.getSurveyDetails.bind(this);
        this.onSurveyFieldValChange = this.onSurveyFieldValChange.bind(this);
        this.onSurveyReqSubmit = this.onSurveyReqSubmit.bind(this);
        this.getGroupStudents = this.getGroupStudents.bind(this);
    }

    componentWillMount = () => {
        const allergiesData = {}
        this.props.studentData.forEach(item => {
            allergiesData[item.id] = item.allergies

        })
        this.setState({
            studentsList: this.props.studentData,
            loading: false,
            allergies: { ...allergiesData },
            existingValues: { ...allergiesData }
        })
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        console.log('this.state.studentsList', this.state.studentsList)
        // this.getSurveyDetails(sessionStorage.getItem('loggedInUserInfo'));
    }

    getGroupBySchool = () => {
        let _schoolsData = this.props.schoolsData || {}
        let SchoolList = {};
        this.state.studentsList.sort(compare).forEach((stud, i) => {
            SchoolList[stud.mealSchoolId] = {
                'schoolName': stud.schoolName,
                'isPaymentEnabled': stud.isPaymentEnabled,
                'stripeAccountId': stud.stripeAccountId,
                'sessionYear': stud.sessionYear,
            }
        })
        Object.keys(SchoolList).forEach((value) => {
            SchoolList[value].students = this.getGroupStudents(value);
            SchoolList[value].events = _schoolsData[value].events || [];
            SchoolList[value].pkgRegStudents = _schoolsData[value].pkgRegStudents || [];
        });
        return SchoolList;
    }

    getGroupStudents = (sid) => {
        let studentsBySchool = [];
        let FinallistObj = {};
        let otherArray = [];
        Object.keys(this.props.menuYearMonth).forEach((value) => {
            FinallistObj[value] = [];
        });
        this.state.studentsList.forEach((std) => {
            if (std.mealSchoolId == sid) {
                studentsBySchool.push(std);
            }
        })

        studentsBySchool.sort(compare).forEach((stud, i) => {
            let myear = getOrderMonthYearByStudent(this.props.menuYearMonth, parseInt(stud._links.self.href.split('/').pop()));
            if (myear == '') {
                otherArray.push(stud);
            }
            else {
                FinallistObj[myear].push(stud);
            }
        })
        if (otherArray.length > 0)
            FinallistObj['others'] = otherArray;
        // console.log("studentsBySchool::::::::::::",FinallistObj);
        return FinallistObj;
    }
    componentWillReceiveProps = (nextProps) => {
        const allergiesData = {}
        nextProps.studentData.forEach(item => {
            allergiesData[item.id] = item.allergies

        })
        this.setState({
            studentsList: nextProps.studentData,
            loading: false,
            allergies: { ...allergiesData },
            existingValues: { ...allergiesData }
        })
    }
    onSurveyReqSubmit(e) {
        e.preventDefault();
        let surveyObj = this.state.survey;
        // Free/Reduced price eligibility Calculation 
        let alertMessage = '';
        surveyObj.isFreeLunchEligible = false;
        surveyObj.isReducedPriceEligible = false;
        let povertyIncome = [12140, 16460, 20780, 25100, 29420, 33740, 38060, 42380, 46700, 51020];
        let Income = parseFloat(surveyObj.income) * parseFloat(surveyObj.incomeType);
        if ((Income / 1.30) <= povertyIncome[parseInt(surveyObj.householdSize)]) {
            surveyObj.isFreeLunchEligible = true;
            surveyObj.isReducedPriceEligible = false;
            alertMessage = '<p className="survey-msg-text">You might be eligible for Free lunch program based on your profile. Contact school for more information</p>';
        } else if ((Income / 1.85) <= povertyIncome[parseInt(surveyObj.householdSize)]) {
            surveyObj.isFreeLunchEligible = false;
            surveyObj.isReducedPriceEligible = true;
            alertMessage = '<p className="survey-msg-text">You might be eligible for Reduced lunch prices program based on your profile. Contact school for more information</p>';
        }
        else {
            surveyObj.isFreeLunchEligible = false;
            surveyObj.isReducedPriceEligible = false;
            alertMessage =
                '<p className="survey-msg-text">You might not be eligible for Free/Reduced lunch program based on your profile. But if your child follows in any of the below category, they might be still eligible. Contact school for more information.' +
                '<br/>• Children in households who are receiving benefits from SNAP, FDPIR or TANF.<br/>\n' +
                '• Foster children that are under the legal responsibility of a foster care agency or court.<br/>\n' +
                '• Children participating in their school’s Head Start program <br/>\n' +
                '• Children who meet the definition of homeless, runaway, or migrant <br/></p>';
        }


        //end


        let headers = {
            'Content-Type': 'application/json'
        };
        if (surveyObj.id > 0) {
            patch('/fMEligibilitySurveys/' + surveyObj.id + '?access_token=', JSON.stringify(surveyObj)).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            }).then(data => {
                document.getElementById("survey").innerHTML = alertMessage;
            }).catch(
                (error) => {
                    this._addNotificationError('Unable to update request ! Try Again.');
                }
            );
        }
        else {
            postWithHeaders('/fMEligibilitySurveys?access_token=', JSON.stringify(surveyObj), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            }).then(data => {
                document.getElementById("survey").innerHTML = alertMessage;
                // this.getSurveyDetails(sessionStorage.getItem('loggedInUserInfo'));

            }).catch(error => {
                this._addNotificationError('Unable to add request ! Try Again.');
            });
        }
    }

    onSubmitPayment = (e, callback) => {
        e.preventDefault();
        const sid = this.state.selectTransStudent.mealSchoolId || 0
        this.setState({ loading: true });
        let headers = {
            'Content-Type': 'application/json'
        };
        let reqBody = {
            "sourceUserId": this.state.selectedStudent.id,
            "targetUserId": this.state.selectTransStudent.id,
            "amount": this.state.payTransferModalObject.totalTransactionAmount
        }
        if ((this.state.selectedStudent.id || '').trim() === '') {
            _addNotificationError("Please Select Source Account Student.", this);
            callback(true);
            return false;
        }
        if ((this.state.payTransferModalObject.totalTransactionAmount || 0) == 0.00) {
            _addNotificationError("Please provide transaction amount.", this);
            callback(true);
            return false;
        }
        if ((this.state.selectTransStudent.id || '').trim() === '') {
            _addNotificationError("Please Select Target Account Student.", this);
            callback(true);
            return false;
        }

        putWithHeadersResponse("/transactions/" + sid + "/balanceTransfer?access_token=", JSON.stringify(reqBody), headers)
            .then((response) => {
                console.log("response:::::", response);
                if (response.status === 200) {
                    this.setState({ loading: false })
                    _addNotification('Balance transferred successfully.', this);
                    callback(true);
                    setTimeout(() =>
                        window.location.replace('/parent')
                        , 3000);
                } else if (!response.ok) {
                    throw Error(response);
                }
                this.setState({ loading: false });
            }).catch(
                (error) => {
                    _addNotificationError('Failed to add payment ! Try again.', this);
                    callback(true);
                    console.log('Send Notification Error', error);
                }
            );
    }

    checkNSLPeligiblity = (e) => {
        //e.preventDefault();
        let povertyIncome = [12140, 16460, 20780, 25100, 29420, 33740, 38060, 42380, 46700, 51020];
        //let Income = e.target.income.value * e.target.incomeType.value;
        let Income = parseFloat(e.income) * parseFloat(e.incomeType);
        if ((Income / 1.30) <= povertyIncome[parseInt(e.householdSize)]) {
            document.getElementById("survey").innerHTML =
                '<p className="survey-msg-text">You might be eligible for Free lunch program based on your profile. Contact school for more information</p>';
        } else if ((Income / 1.85) <= povertyIncome[parseInt(e.householdSize)]) {
            document.getElementById("survey").innerHTML =
                '<p className="survey-msg-text">You might be eligible for Reduced lunch prices program based on your profile. Contact school for more information</p>';
            ;
        } else {
            document.getElementById("survey").innerHTML =
                '<p className="survey-msg-text">You might not be eligible for Free/Reduced lunch program based on your profile. But if your child follows in any of the below category, they might be still eligible. Contact school for more information.' +
                '<br/>• Children in households who are receiving benefits from SNAP, FDPIR or TANF.<br/>\n' +
                '• Foster children that are under the legal responsibility of a foster care agency or court.<br/>\n' +
                '• Children participating in their school’s Head Start program <br/>\n' +
                '• Children who meet the definition of homeless, runaway, or migrant <br/></p>';
            ;
        }
        //this.getSurveyDetails(sessionStorage.getItem('loggedInUserInfo'));

    }
    toggleAllergy = (id, allergies) => {
        var x = document.getElementById("showAllergy" + id);
        document.getElementById("txtAllergies" + id).value = (allergies == undefined ? '' : allergies);
        if (x.style.display === "none") {
            x.style.display = "block";
        } else {
            x.style.display = "none";
        }
    };
    /*  onAllergensChange = (name,id) =>{
         let updatedArray =  this.state.allergies[id] || []
         if(!Array.isArray(updatedArray)){
             updatedArray = updatedArray.split(',')
         }
         if(updatedArray){
             if(updatedArray.includes(name)){
                 updatedArray = updatedArray.filter(item=> item !== name)
                 
                 
             }else{
              
                 if(!Array.isArray(updatedArray)){
                     updatedArray = updatedArray.split(',')   
                 }
                 updatedArray.push(name)
 
 
             }
             this.setState({allergies : {
                 ...this.state.allergies,
                 [id] : updatedArray
             }})
         }else{
             this.setState({allergies : {
                 ...this.state.allergies,
                 [id] : [name]
             }})
         }
 
     } */
    handleStudentChange = (event) => {
        let index = this.state.transferBalStudents.findIndex(obj => obj.id === event.target.value);
        //console.log("index::::",index);
        if (index !== -1) {
            //console.log("this.state.studentsList[index] ::::::::::",this.state.transferBalStudents[index] );
            this.setState({ selectedStudent: this.state.transferBalStudents[index] });
            //console.log("selectedStudent::::::::::",this.state.selectedStudent);
        } else {
            this.setState({ selectedStudent: {} })
        }
    }
    handleTransStudentChange = (event) => {
        let index = this.state.transferBalStudents.findIndex(obj => obj.id === event.target.value);
        if (index !== -1) {
            this.setState({ selectTransStudent: this.state.transferBalStudents[index] });
        } else {
            this.setState({ selectTransStudent: {} })
        }
    }

    closePaymentTrnaferModel = () => {
        this.setState({ transferModalIsOpen: false });
        let payObj = this.state.payTransferModalObject;
        payObj = {};
        payObj.studentWiseTransactions = []
        this.setState({ transferModalIsOpen: false, payTransferModalObject: payObj });
        this.setState({ selectTransStudent: {}, selectedStudent: {} })
    }
    computTransferAmount() {
        let payObj = this.state.payTransferModalObject;
        let _computeAmount = 0.0;
        payObj.studentWiseTransactions.map((s) => {
            _computeAmount = _computeAmount + parseFloat(s.transactionAmount)
        });
        return parseFloat(_computeAmount.toFixed(2));
    }

    toggleContact = (data) => {
        this.setState({ schoolContactModalIsOpen: true, schoolInfo: data })
    }

    transferBal = (data) => {
        console.log("scoolInfo::::::::::::", data)
        // Extract values (arrays) from the object
        let values = Object.values(data);

        // Merge arrays into one using concat and spread syntax
        let result = [].concat(...values);

        this.setState({ transferModalIsOpen: true, scoolInfo: data, transferBalStudents: result });
        console.log("transferBalStudents::::", this.state.transferBalStudents);
    }

    /*  handleAllergensTextChange = (event,id) =>{
         this.setState({allergies : {
             ...this.state.allergies,
             [id] : event.target.value
         }})
     } */
    AllergyRecSubmit = (data = '', id) => {
        let body = {
            'allergies': (data.trim()).length > 0 ? data : null
        };
        patch('/studentUsers/' + id + '?access_token=', JSON.stringify(body)).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let studList = this.state.studentsList;
            console.log(studList);
            let allergensOpenObj = this.state.allergensOpen;
            for (var i = 0; i < studList.length; i++) {
                if (studList[i].id == id) {
                    studList[i].allergies = data.allergies;

                    allergensOpenObj[id] = false
                }
            }
            const a = this.state.existingValues;
            a[id] = body.allergies;
            let _allergies = this.state.allergies;
            _allergies[id] = body.allergies;
            this.setState({
                studentsList: [...studList],
                allergens: _allergies,
                allergensOpen: allergensOpenObj,
                existingValues: a
            }, () => {
                this.forceUpdate();
            });

            //  this.toggleAllergy(id, '');

        }).catch(
            (error) => {
                this._addNotificationError('Unable to add allergies ! Try Again.');
                console.log('Add allergies response', error);
                //this.toggleAllergy(id, '');
            }
        );

    }
    editSpendLimit = (id, spendLimit) => {
        var x = document.getElementById("showLimit" + id);
        document.getElementById("inputLimit" + id).value = (spendLimit == undefined ? '' : spendLimit);
        if (x.style.display === "none") {
            x.style.display = "block";
        } else {
            x.style.display = "none";
        }
    }
    handleEditSpendingLimit = (e) => {
        let amount = e.target.value;
        this.setState({ spendLimitAmount: amount });
    }
    spendLimitSubmit = (id) => {
        let body = {
            'spendingLimit': this.state.spendLimitAmount
        };
        patch('/studentUsers/' + id + '?access_token=', JSON.stringify(body)).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.JSON;
        }).then(data => {
            let studList = [...this.state.studentsList];
            console.log(studList);
            for (var i = 0; i < studList.length; i++) {
                if (studList[i].id == id) {
                    studList[i].spendingLimit = this.state.spendLimitAmount;
                }
            }
            this.setState({ studentsList: studList });
            this.editSpendLimit(id, '');

        }).catch(
            (error) => {
                this._addNotificationError('Unable to save Spending Limit ! Try Again.');
                console.log('Add spending limit response', error);
                this.editSpendLimit(id, '');
            }
        );
    }
    _addNotificationError(message) {
        this._notificationSystem.addNotification({
            title: "Failed",
            message: message,
            level: 'error',
            position: 'tc',
            autoDismiss: '5',
            uid: 5,

        });
    }

    /* getSurveyDetails(parent) {
        this.setState({ loading: true });
        get('/fMEligibilitySurveys/search/findByParentEmail?parentEmail=' + parent + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let surveyObj = this.state.survey;
            surveyObj.parentEmail = data.parentEmail;
            surveyObj.householdSize = data.householdSize;
            surveyObj.income = data.income;
            surveyObj.incomeType = data.incomeType;
            surveyObj.id = data._links.self.href.split('/').pop();
            surveyObj.loggedUser = sessionStorage.getItem('loggedInUserInfo');
            this.setState({ survey: surveyObj, loading: false });
        })
            .catch(
                (error) => {
                    console.log('Get SchoolList response', error)
                    this.setState({ loading: false });
                }
            )

    } */
    onSurveyFieldValChange(event) {
        let surveyObj = this.state.survey;
        surveyObj[event.target.name] = event.target.value;
        this.setState({ survey: surveyObj });
    }
    getOtherAllergens = (id) => {
        let allergensArray = []
        if (this.state.allergies[id] && Array.isArray(this.state.allergies[id])) {
            allergensArray = this.state.allergies[id]
        } else if (typeof (this.state.allergies[id]) === 'string') {
            allergensArray = this.state.allergies[id].split(',')
        }
        const finalArray = allergensArray.filter((item) => {
            let isExisted = false
            Object.keys(allergens).some((itm, i) => {
                if (allergens[itm].display === item) {
                    isExisted = true
                    return true
                }
                return false
            })
            return !isExisted
        });

        return finalArray.map(itm => {
            return (
                <div className="mb-4 col-sm-3 col-md-3" style={{ display: "inline-block", textAlign: "center", marginBottom: "8px" }}>
                    <div className="mb-6 col-sm-12 col-md-12" style={styles.itemStyle}>
                        <button onClick={(e) => {
                            e.preventDefault()
                        }} className='btn-primary'
                            style={{
                                padding: '4px',
                                borderRadius: '50%',
                            }}>
                            <i className="fa fa-info" />
                        </button>
                        <span className="" style={{
                            //width: '65%',
                            background: 'transparent',
                            color: 'rgb(117 117 118)',
                            border: '0',
                            fontSize: '13px',
                            fontWeight: 'bold'
                        }}>{itm}</span>
                    </div>
                </div>)
        }

        )
    }
    openModel = (stud) => {
        let allergensOpenObj = this.state.allergensOpen;
        allergensOpenObj[stud.id] = true;
        this.setState({ allergensOpen: allergensOpenObj });
    }
    studentCard = (stud, index, list) => {
        const gradeGroup = groupBy(getSchoolGrades(stud.mealSchoolId), 'value');
        const label = ((gradeGroup[stud.gradeName] || [])[0] || {}).label;
        stud.id = stud._links.self.href.split('/').pop();
        stud.orderStatus = stud.orderStatus || 0
        return <div key={index} className="col-md-4 col-sm-6 studentTile" style={{ padding: 0, paddingRight: '10px' }}>
            <div className="media teamStyle">

                <div className="media-body">
                    <div className='row'>
                        <div className='col-md-6 col-xs-12'>
                            <div className='row'>
                                <a className="media-left text-center" >
                                    <img className="img-rounded img-responsive" style={{ widht: '100px', height: '80px' }}
                                        src={(stud.image || '') === '' ? defaultImg : stud.image} alt="Student image" />

                                </a>
                                <p className="media-heading" style={{ marginBottom: '0px', marginTop: '12px' }}>
                                    <h4 style={{ margin: '8px' }}>{stud.firstName + ' ' + stud.lastName}
                                    </h4>
                                    {getAccessLevelByModule(modEnum.NSO, stud.mealSchoolId) ? null :

                                        <span style={{ display: 'block', fontSize: 'small', fontWeight: '600', color: 'rgb(228, 14, 38)', textTransform: 'capitalize' }}>{'Grade: '} <i style={{ paddingRight: 5 }}>{label}</i></span>
                                    }
                                </p>

                            </div>

                            <div className='row'>
                                {
                                    getAccessLevelByModule(modEnum.APCC, stud.mealSchoolId) || getAccessLevelByModule(modEnum.APO, stud.mealSchoolId) ?
                                        <span
                                            style={{ margin: "10px 0px 0px 10px" }}>
                                            <label >Balance: &nbsp;&nbsp; </label>{currency_symbol(stud.mealSchoolId) + ' ' + convertTwoDecimalPoint(stud.accBalance,)}
                                        </span> : null
                                }
                                {
                                    getAccessLevelByModule(modEnum.LETM, stud.mealSchoolId) ?
                                        <div style={{ margin: "0px 0px 0px 10px" }}><label >{'Eligibility:'}&nbsp;
                                        </label><i>{stud.isFreeMealEligible ? "Free" : (stud.isReducePriceEligible ? "Reduced" : "Regular")}</i>
                                        </div> : null
                                }
                                {
                                    getAccessLevelByModule(modEnum.NSO, stud.mealSchoolId) ? null :
                                        stud.pin ? <div style={{ margin: "0px 0px 0px 10px" }}><label >{'Pos Pin:'}&nbsp;
                                        </label><i>{stud.pin}</i>
                                        </div> : null
                                }
                            </div>
                            {
                                getAccessLevelByModule(modEnum.NSO, stud.mealSchoolId) ? null : <Fragment>
                                    {getAccessLevelByModule(modEnum.MKA, stud.mealSchoolId) ? <Fragment>
                                        <div className='row'>
                                            <div className="col-md-12" style={{ paddingLeft: '10px' }}>
                                                <label className="sub-title" style={{ marginBottom: '10px' }} >{'Allergies'} &nbsp;&nbsp;
                                                    <i onClick={() => {
                                                        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'))[stud.mealSchoolId];
                                                        //console.log("Student Country code:"+countryCode);
                                                        this.setState({ studentCountryCode: countryCode }, () => {
                                                            this.openModel(stud);
                                                        });
                                                    }}
                                                        style={{ cursor: "pointer" }}
                                                        className="fa fa-pencil" aria-hidden="true"></i>  </label>
                                            </div>
                                        </div>

                                        {/* -------commented: dont delete this comment-------
                                 <div className='row' style={{marginLeft:'0px'}}>
                                {
                               
                                    Object.keys(allergens).map((itm, i)=>{
                                        if((this.state.allergies[stud.id] && this.state.allergies[stud.id].includes(allergens[itm].display))){
                                            return (<div className="mb-4 col-sm-3 col-md-3" style={{display:"inline-block",textAlign:"center",marginBottom:"8px"}}>
                                                <div className="mb-6 col-sm-12 col-md-12" style={styles.itemStyle}>
                                                    <button onClick={(e)=>{
                                                        e.preventDefault()
                                                    }} class={`${(this.state.allergies[stud.id] && this.state.allergies[stud.id].includes(allergens[itm].display)) ? 'btn-primary' : 'btn-allergens'}`} 
                                                    style={itm !== 'fish' ? (itm!=='eggs' ? styles.allergensButtonStyle : styles.eggButtonStyle): styles.fishStyle}>
                                                        <img src={allergens[itm].image} className="img-fluid" alt="..." style={itm !== 'fish' ? (itm!=='eggs' ? styles.imageStyle : styles.eggImageStyle) : styles.fishImageStyle} />
                                                    </button>
                                                    <span className="" style={{
                                                        //width: '65%',
                                                        background: 'transparent',
                                                        border: '0',
                                                        fontSize:'13px',
                                                        fontWeight:'bold'
                                                    }}>{allergens[itm].display}</span>
                                                </div>
                                            </div> )
                                    }
                                    return null                                   
                               })                               
                           }
                         
                            {this.getOtherAllergens(stud.id)}
                            
                        </div>  */}
                                        <AllergensModel
                                            closeAllergensModel={() => {
                                                let allergensOpenObj = this.state.allergensOpen
                                                allergensOpenObj[stud.id] = false
                                                const a = this.state.existingValues
                                                const allergies = this.state.allergies
                                                allergies[stud.id] = a[stud.id]

                                                this.setState({ allergensOpen: allergensOpenObj, allergies: allergies })
                                            }}
                                            open={this.state.allergensOpen[stud.id]}
                                            //onAllergensChange={this.onAllergensChange}
                                            selectedAllergies={this.state.allergies}
                                            stud={stud}
                                            studentCountryCode={this.state.studentCountryCode}
                                            AllergyRecSubmit={this.AllergyRecSubmit}
                                            allergiesObj={this.state.allergies}
                                        />
                                    </Fragment> : null

                                    }
                                    {stud.dailySpendingLimit ? <div className='row'>
                                        <Fragment>
                                            <span style={{ margin: "10px 0px 0px 10px" }}> <label>Spend Limit:&nbsp;&nbsp;
                                            </label>{currency_symbol(stud.mealSchoolId) + ' ' + convertTwoDecimalPoint(stud.spendingLimit,)}&nbsp;&nbsp;
                                                <i onClick={() => {
                                                    this.editSpendLimit(stud.id, stud.spendingLimit)
                                                }}
                                                    style={{ cursor: "pointer" }}
                                                    className="fa fa-pencil" aria-hidden="true"></i></span>
                                            <form id={"showLimit" + stud.id} name={"showLimit" + stud.id} style={{ display: "none" }}>
                                                <div>
                                                    <div className="input-group">
                                                        <span className="input-group-addon" id="basic-addon1">{currency_symbol(stud.mealSchoolId)}</span>
                                                        <input type="text" id={"inputLimit" + stud.id} name="spendLimit" value={this.state.spendLimitAmount}
                                                            onChange={(e) => { this.handleEditSpendingLimit(e) }} className="form-control"
                                                            onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                            placeholder="Amount" />
                                                    </div>
                                                </div>
                                                <input type="button" className="allergies-success" value={(stud.spendingLimit == undefined ? '' : stud.spendingLimit) == '' ? "Save" : "Update"}
                                                    onClick={() => {
                                                        this.spendLimitSubmit(stud.id)
                                                    }} />
                                                <input type="button" className="allergies-primary"
                                                    onClick={() => {
                                                        this.editSpendLimit(stud.id, '');
                                                    }} value="Cancel" />
                                            </form>
                                        </Fragment>
                                    </div> : null}
                                </Fragment>
                            }


                        </div>
                        <div className='col-md-6 col-xs-12'>
                            <div style={{ borderLeft: '1px solid rgba(0, 0, 0, 0.1)' }}>
                                <ul class="list-group" >
                                    {
                                        (getAccessLevelByModule(modEnum.BOM, stud.mealSchoolId) ||
                                            getAccessLevelByModule(modEnum.LOM, stud.mealSchoolId) ||
                                            getAccessLevelByModule(modEnum.SOM, stud.mealSchoolId) ||
                                            getAccessLevelByModule(modEnum.DOM, stud.mealSchoolId)) ?
                                            <li class="list-group-item" style={{ border: '0px', padding: 0 }}>
                                                < Link className="btn btn-sm btn-success bg-color-5" style={{ marginBottom: 0, minWidth: "90%" }} to={{
                                                    pathname: '/parent/menu/' + stud.id + '/' + stud.orderStatus,
                                                    state: {
                                                        schoolId: stud.mealSchoolId,
                                                        lunchBal: stud.accBalance,
                                                        list: list
                                                    }
                                                }}
                                                >
                                                    <strong><i className="fa fa-cutlery"
                                                        aria-hidden="true"></i>
                                                        {
                                                            (stud.orderStatus !== 0 ?
                                                                (stud.orderStatus === "update" ?
                                                                    (<span>Order Meals  <i
                                                                        className="fa fa-check-circle"
                                                                        style={{ color: 'green' }}></i>    </span>) :
                                                                    <span>Order Meals&nbsp;
                                                                        <i
                                                                            className="flash fa fa-exclamation-circle fa-1x"
                                                                            style={{ color: 'red' }}></i></span>)
                                                                :
                                                                <span>Order Meals</span>
                                                            )}
                                                    </strong>

                                                </Link>
                                            </li> : null

                                    }
                                    {
                                        (getAccessLevelByModule(modEnum.VBM, stud.mealSchoolId) ||
                                            getAccessLevelByModule(modEnum.VSM, stud.mealSchoolId) ||
                                            getAccessLevelByModule(modEnum.VLM, stud.mealSchoolId) ||
                                            getAccessLevelByModule(modEnum.VDM, stud.mealSchoolId)) ?
                                            <li class="list-group-item" style={{ border: '0px', padding: 0 }}>
                                                < Link className="btn btn-sm btn-success bg-color-1" style={{ marginBottom: 0, minWidth: "90%" }} to={{
                                                    pathname: '/parent/viewmenu',
                                                    state: {
                                                        student: stud
                                                    }
                                                }}
                                                > <strong><i className="fa fa-cutlery" aria-hidden="true"></i>
                                                        <span> View Menu</span> </strong></ Link> </li>
                                            : null
                                    }
                                    {
                                        (getAccessLevelByModule(modEnum.BOM, stud.mealSchoolId) ||
                                            getAccessLevelByModule(modEnum.LOM, stud.mealSchoolId) ||
                                            getAccessLevelByModule(modEnum.SOM, stud.mealSchoolId) ||
                                            getAccessLevelByModule(modEnum.DOM, stud.mealSchoolId)) ?
                                            <li class="list-group-item" style={{ border: '0px', padding: 0 }}>
                                                <Link className="btn btn-sm btn-success bg-color-4" style={{ marginBottom: 0, minWidth: "90%" }} to={{
                                                    pathname: '/parent/orders/' + stud.id,
                                                    state: {
                                                        schoolId: stud.mealSchoolId,
                                                        schoolYear: stud.schoolYear
                                                    }
                                                }}
                                                ><strong style={{ fontSize: '13px' }}><i
                                                    className="fa fa-eye"></i> <span>View Orders</span></strong></Link>

                                            </li> : null
                                    }
                                    <li class="list-group-item" style={{ border: '0px', padding: 0 }}>
                                        <Link className="btn btn-sm btn-success bg-color-3" style={{ marginBottom: 0, minWidth: "90%" }} to={{
                                            pathname: '/parent/accountHistory/' + stud.id,
                                            state: {
                                                schoolId: stud.mealSchoolId,
                                            }
                                        }} ><strong style={{ fontSize: '13px' }}><i
                                            className="fa fa-list-alt"></i> <span>Account History</span></strong></Link>

                                    </li>
                                    {
                                        getAccessLevelByModule(modEnum.NSO, stud.mealSchoolId) ? null : <Fragment>

                                            {
                                                getAccessLevelByModule(modEnum.BACP, stud.mealSchoolId) ?
                                                    <li class="list-group-item" style={{ border: '0px', padding: 0, paddingBottom: '22px' }}>
                                                        <Link className="btn btn-sm btn-success bg-color-2" style={{ marginBottom: 0, minWidth: "90%" }} to={{
                                                            pathname: '/parent/bcacReport/' + stud.id,
                                                            state: {
                                                                schoolId: stud.mealSchoolId,
                                                                schoolYear: stud.schoolYear,
                                                                studentName: (stud.firstName || '') + ' ' + (stud.lastName || '')
                                                            }
                                                        }}><strong style={{ fontSize: '13px' }}><i
                                                            className="fa fa-eye"></i> <span>BCAC Report</span></strong></Link>
                                                    </li> : null
                                            }
                                        </Fragment>
                                    }


                                </ul>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    }
    bindSchoolGroups = (list) => {
        let sidlist = Object.keys(list);
        // console.log("sidlist:::::::::::::::::",list);
        return (
            (sidlist.length > 0) ? (<div>
                <span className="parent-bookmark" title="Bookmark" style={{ display: 'none' }}>
                    <i className="fa fa-bookmark bg-color-8" aria-hidden="true"></i>
                </span>
                <div className="accordionCommon" id="accordionOne">
                    <div className="panel-group" id="accordionMainFirst">
                        {
                            sidlist.map((value, index) => {
                                console.log("sidList value::::::", list[value].students);
                                let stdCount = 0;
                                for (let key in list[value].students) {
                                    if (Array.isArray(list[value].students[key]) && list[value].students[key].length > 0) {
                                        stdCount += list[value].students[key].length;
                                    }
                                }

                                let schoolYear = list[value].sessionYear.schoolYearValue;
                                if (!getAccessLevelByModule(modEnum.PR, value)) {
                                    return null;
                                }
                                return (
                                    <div className="panel-default">
                                        <div className="panel-heading accordion-toggle" style={{ padding: '7px 7px', marginBottom: '7px', backgroundColor: '#D2D7D4', marginLeft: "-15px", marginRight: "-15px" }}>
                                            <div className="row">
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <a className="accordionTitleBlock" data-toggle="collapse"
                                                        data-parent="#accordionMainFirst"
                                                        href={"#collapse-School" + "-" + index + '-' + value}>
                                                        <span style={{ color: '#0a0000' }}>{list[value].schoolName + ' [ ' + list[value].sessionYear.schoolYear + ' ]'}</span>  </a>
                                                </div>

                                                <div className="col-md-3">
                                                    {getAccessLevelByModule(modEnum.NSO, value) ? null : <Fragment>
                                                        {
                                                            getAccessLevelByModule(modEnum.AEM, value) ?
                                                                list[value].events.length > 0 ?
                                                                    <marquee width="100%" direction="left">
                                                                        <Link style={{ color: "#f90404" }} to={'/parent/eventpayment/' + value + '/' + schoolYear}>
                                                                            {list[value].events[0].eventName}
                                                                        </Link></marquee> : null : null
                                                        }</Fragment>
                                                    }
                                                </div>
                                                <div className="col-md-3 text-right">
                                                    <a href="javascript:void(0)"
                                                        onClick={() => {
                                                            this.toggleContact(this.state.studentsList.find(s => s.mealSchoolId == value) || this.state.studentsList[0])
                                                        }}><strong>
                                                            {/* <i className="fa fa-info-circle color-1" aria-hidden="true"></i> */}
                                                            {getAccessLevelByModule(modEnum.NSO, value) ? 'Contact' : 'School Contact'}</strong></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div id={"collapse-School" + "-" + index + '-' + value} className="panel-collapse collapse in">
                                            <div className="accordionCommon" id={'accordionOne-' + index}>
                                                <div className="panel-body" id={"accordionChild" + value} style={{ "padding": "0px", backgroundColor: "#ffffff", borderRadius: "0px" }}>
                                                    {this.bindGroupStudents(list[value].students, value)}
                                                </div>
                                                <div className="panel-footer" style={{ backgroundColor: "#ffffff" }}>
                                                    <div className="row">
                                                        <div className="pull-right device-btn-style button-group-section">
                                                            {
                                                                getAccessLevelByModule(modEnum.NSO, value) ? null : <Fragment>
                                                                    {
                                                                        getAccessLevelByModule(modEnum.BACP, value) ?
                                                                            <button type="button" data-schId={value}
                                                                                onClick={(e) => {
                                                                                    const self = this;
                                                                                    self.props.history.push({
                                                                                        pathname: '/parent/bcacEnrollmentHistory',
                                                                                        state: {
                                                                                            schoolObject: list[value],
                                                                                            sid: value,
                                                                                            pkgRegStudents: list[value].pkgRegStudents
                                                                                        }
                                                                                    });
                                                                                }} className="btn btn-sm btn-success bg-color-3" ><i className="fa fa-tasks" aria-hidden="true"></i> {((list[value].pkgRegStudents || []).length > 0) ? 'Pay BCAC Program' : 'BC&AC Enrollments'} </button> :
                                                                            null}
                                                                </Fragment>
                                                            }
                                                            {

                                                                (stdCount > 1) ?
                                                                    (<a onClick={() => { this.transferBal(list[value].students) }}
                                                                        className="btn btn-sm btn-success bg-color-9"
                                                                        title="Transfer Balance"  >
                                                                        <i className=
                                                                            "fa fa-money" aria-hidden="true" ></i> <span>Transfer Balance</span></a>
                                                                    )
                                                                    : null
                                                            }
                                                            {
                                                                (partnerSchoolList.includes(parseInt(convertTwoDecimalPoint(value))) ?
                                                                    <a onClick={() => {
                                                                        window.open(
                                                                            `${PARTNER_PAYMENT_URL}`,
                                                                            '_blank'
                                                                        );
                                                                    }} className="btn btn-sm btn-success bg-color-6"
                                                                        title="Add Funds  to Meal Account"  >
                                                                        <i className=
                                                                            "fa fa-money" aria-hidden="true" ></i> <span>Add Funds  to Meal Account</span></a> :
                                                                    getAccessLevelByModule(modEnum.APO, value) ?
                                                                        (<a onClick={() => { this.onAdvancePayClick('school', list[value].students) }}
                                                                            className="btn btn-sm btn-success bg-color-6"
                                                                            title="Add Balance"  >
                                                                            <i className=
                                                                                "fa fa-money" aria-hidden="true" ></i> <span>Add Balance</span></a>
                                                                        )
                                                                        : null)
                                                            }
                                                            {
                                                                getAccessLevelByModule(modEnum.NSO, value) ? null : <Fragment>
                                                                    {
                                                                        getAccessLevelByModule(modEnum.OLEA, value) ?
                                                                            // <Link className="btn btn-sm btn-success bg-color-1" 
                                                                            // to={{pathname:'/parent/lunchbreakfastprogram/'+value,
                                                                            // state:{
                                                                            //     schoolObject:list[value],
                                                                            //     sid:value
                                                                            // }}}>
                                                                            <Link className="btn btn-sm btn-success bg-color-1"
                                                                                to={{
                                                                                    pathname: '/parent/mealbenifitsapplications/',
                                                                                    state: {
                                                                                        schoolObject: list[value],
                                                                                        sid: value
                                                                                    }
                                                                                }}>
                                                                                <i className="fa fa-paperclip" aria-hidden="true"></i> School Meal Benefits application
                                                                            </Link> : null
                                                                    }
                                                                    {
                                                                        getAccessLevelByModule(modEnum.ESEA, value) ?
                                                                            <Link data-schId={value}
                                                                                to={{
                                                                                    pathname: '/parent/eseaApplication/',
                                                                                    state: {
                                                                                        schoolsObject: list,
                                                                                        sid: value,
                                                                                        schoolYear,
                                                                                        parentEmail: sessionStorage.getItem('loggedInUserInfo')
                                                                                    }
                                                                                }} className="btn btn-sm btn-success bg-color-3" >
                                                                                <i className="fa fa-id-card-o" aria-hidden="true"> ESEA Form</i>
                                                                            </Link> :
                                                                            null}
                                                                    {
                                                                        getAccessLevelByModule(modEnum.AEM, value) ?
                                                                            <button type="button" data-schId={value}
                                                                                disabled={list[value].events.length > 0 ? false : true}
                                                                                onClick={(e) => {
                                                                                    this.props.history.push('/parent/eventpayment/' + value + '/' + schoolYear);
                                                                                }} className="btn btn-sm btn-success bg-color-5" ><i className="fa fa-tasks" aria-hidden="true"> Events</i></button> :
                                                                            null}

                                                                    <Link type="button" to={{
                                                                        pathname: '/parent/settings',
                                                                        state: {
                                                                            schoolObject: {
                                                                                schoolId: value,
                                                                                schoolYear: schoolYear,
                                                                                schoolName: list[value].schoolName
                                                                            },
                                                                            students: groupBy(this.state.studentsList, 'mealSchoolId')[value],
                                                                            sid: value
                                                                        }
                                                                    }} className="btn btn-sm btn-success bg-color-4" ><i className="fa fa-sliders" aria-hidden="true"> Settings</i></Link>
                                                                </Fragment>
                                                            }

                                                        </div>


                                                    </div>
                                                    {/* <div className="row">
                                                        <div className="col-md-12">
                                                            <h4 style={{ marginBottom: '6px' }}><span >Demo Videos</span></h4>
                                                            <DemoVideos listItems={
                                                                isRegularLunchOrderType(value) ?
                                                                    (getAccessLevelByModule(modEnum.APO, value) ?
                                                                        [{ title: 'Place Order', link: 'https://www.youtube.com/embed/JseWbf9053A?vq=hd1080' },
                                                                        { title: 'Add Balance', link: 'https://www.youtube.com/embed/cBdVX44lGQ0?vq=hd1080' }] :
                                                                        [{ title: 'Place Order', link: 'https://www.youtube.com/embed/JseWbf9053A?vq=hd1080' }])
                                                                    : [
                                                                        { title: 'Pre Ordering', link: 'https://www.youtube.com/embed/iB3jR9MRSkw' }
                                                                    ]} />

                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div> </div></div>)
                            })
                        }
                    </div>
                </div>
            </div>) : <p className="text-center col-lg-12 col-md-12 col-xs-12 col-sm-12">No Kids Found with this EmailId</p>
        )

    }

    bindGroupStudents = (list, sid) => {
        let mlist = Object.keys(list);
        let allStudents = [];
        let isAllEmpty = true;
        mlist.forEach((myear, index) => {
            if (list[myear].length > 0) {
                allStudents = allStudents.concat(list[myear])
                isAllEmpty = false;
            }

        })
        return (
            <div className='row'>
                {(allStudents.length > 0) ?
                    allStudents.map((stud, i) => {
                        return this.studentCard(stud, i, list)
                    })
                    : <p className="text-center col-lg-12 col-md-12 col-xs-12 col-sm-12">No Kids Found with this EmailId</p>}
            </div>
        )
    }
    onAdvancePayClick = (type, studentObj) => {
        let rows = [];
        if (type === 'school') {
            Object.keys(studentObj).forEach((keyname) => {
                rows = rows.concat(studentObj[keyname]);
            })
        } else {
            rows.push(studentObj);
        }
        this.addPayment(type, rows);
    }
    addPayment = (action, row) => {
        let payObj = this.state.payModalObject;
        payObj.mealSchoolId = row[0].mealSchoolId;
        payObj.schoolName = row[0].schoolName;
        payObj.logoUrl = row[0].logoUrl;
        payObj.transactionType = "Deposit",
            payObj.paymentType = "Online",
            payObj.transactionDescription = 'Paid amount in advance through online';
        payObj.totalTransactionAmount = 0.00;
        if (action === 'student') {
            payObj.studentWiseTransactions = [
                {
                    studentRecId: row[0].id,
                    name: row[0].firstName + ' ' + row[0].lastName,
                    balAmt: row[0].accBalance,
                    transactionAmount: 0.00
                }
            ] //{ "studentRecId":375,"name":"","balAmt":0.00,"transactionAmount":200},                 

        } else {
            let selectedRows = row
            if (selectedRows.length > 0) {
                selectedRows.map((r) => {
                    payObj.studentWiseTransactions.push(
                        {
                            studentRecId: r._links.self.href.split("/").pop(),
                            name: r.firstName + ' ' + r.lastName,
                            balAmt: r.accBalance,
                            transactionAmount: 0.00
                        }
                    )
                });
            }
            else {
                return
            }
        }
        this.props.onSelectStudentsForPay(payObj);
        this.props.history.push({
            pathname: '/parent/checkout',
            state: { onSelectStudentsForPay: payObj }
        });
        //this.setState({modalPayIsOpen:true,payModalObject:payObj});
    }






    render() {
        var stylInline = {
            display: 'inline'
        };

        //   
        console.log('this.state.studentsList', this.state.studentsList)
        let myearsArray = this.props.menuYearMonth
        let studentsInMonthYear = []
        return (

            <div>
                <section className="full-width clearfix" style={{ marginTop: '20px' }}>
                    <NotificationSystem ref="notificationSystem" />
                    <div className="container parent-container" style={{ minHeight: 445 }}>

                        {
                            this.bindSchoolGroups(this.getGroupBySchool())
                        }
                        <div >


                        </div>


                    </div>
                    <Modal
                        isOpen={this.state.schoolContactModalIsOpen}
                        onRequestClose={() => this.setState({ schoolContactModalIsOpen: false })}
                        style={schoolContactStyles}
                        contentLabel="Activation"
                    >
                        <div className="modal-header text-center" style={{ padding: '0 0 15px' }}>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => {
                                this.setState({ schoolContactModalIsOpen: false })
                            }}>&times;</button>
                            <h5 className="modal-title text-center theme_red_color"><b>{getAccessLevelByModule(modEnum.NSO, this.state.schoolInfo.mealSchoolId) ? 'Contact Information' : 'School Contact Information'} </b>
                            </h5>
                        </div>
                        {(this.state.schoolInfo.contactPName !== null && this.state.schoolInfo.contactPEmail !== null && this.state.schoolInfo.contactPPhone !== null) ?
                            <div className="modal-body pull-left" id="schoolInfo">
                                <strong>
                                    <span>{this.state.schoolInfo.contactPName}</span><br />
                                    <span>FOOD SERVICE MANAGER</span><br />
                                    <span>{this.state.schoolInfo.schoolName}</span><br /><br />
                                    <span className="theme_red_color">Email</span><br />
                                    <span>{this.state.schoolInfo.contactPEmail}</span><br /><br />
                                    <span className="theme_red_color">Telephone</span><br />
                                    <span>{this.state.schoolInfo.contactPPhone}</span><br />
                                </strong>
                            </div> :
                            <div>
                                No data found.
                            </div>
                        }
                    </Modal>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={() => this.setState({ modalIsOpen: false })}
                        style={modalStyles}
                        contentLabel="Activation"
                    >
                        <div className="modal-header text-center" style={{ padding: '0 0 15px' }}>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => {
                                this.setState({ modalIsOpen: false })
                            }}>&times;</button>
                            <h5 className="modal-title text-center"><b><a
                                href="https://www.fns.usda.gov/nslp/national-school-lunch-program-nslp" target="_blank">National
                                School Lunch Program (NSLP)</a> Eligibility Survey</b></h5>
                        </div>
                        <div className="modal-body" id="survey">

                            <form name="frmSurvey" onSubmit={this.onSurveyReqSubmit}>
                                <div className="form-group clearfix">
                                    <label className="col-md-4">Household size :</label>
                                    <div className="col-md-4">
                                        <select name="householdSize" className="form-control" onChange={this.onSurveyFieldValChange} required value={this.state.survey.householdSize}>
                                            <option value='0' disabled selected></option>
                                            {
                                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(size => {
                                                    return <option value={size}>{size}</option>

                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group clearfix">
                                    <label className="col-md-4">Income:</label>
                                    <div className="col-md-4 form-group clearfix">
                                        <div className="input-group">
                                            <span className="input-group-addon">{currency_symbol()}</span>
                                            <input type="number" className="form-control" name="income" value={this.state.survey.income} required onChange={this.onSurveyFieldValChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <select name="incomeType" className="form-control" required value={this.state.survey.incomeType} onChange={this.onSurveyFieldValChange}>
                                            <option value={1} selected>Annually</option>
                                            <option value={12}>Monthly</option>
                                            <option value={24}>Twice per
                                                month
                                            </option>
                                            <option value={26}>Bi-Weekly</option>
                                            <option value={52}>Weekly</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="col-md-offset-8 col-md-4 text-right">
                                        <input type="submit" className="btn btn-primary" value="Check eligibility"
                                            style={{ margin: '0' }} />
                                    </div>
                                </div>
                            </form>

                        </div>
                    </Modal>
                    <Modal isOpen={this.state.transferModalIsOpen} style={modalStyles} >
                        <div className="modal-header row">
                            <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Transfer Balance</h4>
                            <div className="col-md-6"><button type="button" className="pull-right btn-danger" onClick={() => this.closePaymentTrnaferModel()}>X</button></div>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12">
                                    <form name="frmPay" className="">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-12">
                                                <h5 className="color-6 h5-transfer-border">Transfer Source Account Details:</h5>
                                                <table className="table table-payment-modal" style={{ marginBottom: '0px' }}>
                                                    <thead><tr>
                                                        <td>Name</td>
                                                        <td>Available Bal</td>
                                                        <td>Amount</td></tr>
                                                    </thead>
                                                    <tbody style={{ maxHeight: '200px', overflowY: 'auto', display: 'block' }}>
                                                        <tr>
                                                            <td>
                                                                <div>
                                                                    <select className="form-control" value={this.state.selectedStudent.id} onChange={this.handleStudentChange}>
                                                                        <option value="">Select a Student</option>
                                                                        {this.state.transferBalStudents.map(student => (
                                                                            <option key={student.id} value={student.id}>
                                                                                {student.firstName} {student.lastName}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {(Object.keys(this.state.transferBalStudents).length > 0) ? currency_symbol(this.state.transferBalStudents[0].mealSchoolId) + ' ' + convertTwoDecimalPoint(this.state.selectedStudent.accBalance,) : 0.00}
                                                            </td>
                                                            <td>
                                                                <div className="input-group">
                                                                    <span className="input-group-addon">{(Object.keys(this.state.transferBalStudents).length > 0) ? currency_symbol(this.state.transferBalStudents[0].mealSchoolId) : '$'}</span>
                                                                    <input type="text"
                                                                        disabled=""
                                                                        className="form-control" name="amount" value={this.state.payTransferModalObject.totalTransactionAmount}
                                                                        onKeyPress={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                        onKeyUp={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                        onBlur={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                        placeholder="0.00" onChange={(e) => {
                                                                            let payObj = this.state.payTransferModalObject;

                                                                            // if(e.target.value > this.state.studentsList.accBalance||e.target.value > convertTwoDecimalPoint(this.state.selectedStudent.accBalance)){
                                                                            if (e.target.value > this.state.selectedStudent.accBalance) {
                                                                                _addNotificationError("Insufficient amount.", this);
                                                                                return false;
                                                                            }
                                                                            payObj.totalTransactionAmount = e.target.value;
                                                                            if (payObj.studentWiseTransactions.length === 1) {
                                                                                payObj.studentWiseTransactions[0].transactionAmount = payObj.totalTransactionAmount
                                                                            }
                                                                            this.setState({ payTransferModalObject: payObj })
                                                                        }} />
                                                                </div></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <h5 className="color-6 h5-transfer-border">Transfer Target Account Details:</h5>

                                                <div className="row">
                                                    <div className="col-xs-12 col-sm-12 col-md-12">
                                                        <table className="table table-payment-modal">
                                                            <thead><tr>
                                                                <td>Name</td>
                                                                <td>Available Bal</td>
                                                                <td>Amount</td></tr>
                                                            </thead>
                                                            <tbody style={{ maxHeight: '200px', overflowY: 'auto', display: 'block' }}>
                                                                <tr>
                                                                    <td>
                                                                        <div>
                                                                            <select className="form-control" value={this.state.selectTransStudent.id} onChange={this.handleTransStudentChange} >
                                                                                <option value="">Select a Student</option>
                                                                                {this.state.transferBalStudents.map(student => (
                                                                                    <option key={student.id} value={student.id} disabled={this.state.selectedStudent.id == student.id}>
                                                                                        {student.firstName} {student.lastName}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        {(Object.keys(this.state.transferBalStudents).length > 0) ? currency_symbol(this.state.transferBalStudents[0].mealSchoolId) + ' ' + convertTwoDecimalPoint(this.state.selectTransStudent.accBalance,) : 0.00}
                                                                    </td>
                                                                    <td>
                                                                        <div className="input-group">
                                                                            <span className="input-group-addon" id="basic-addon1">{(Object.keys(this.state.transferBalStudents).length > 0) ? currency_symbol(this.state.transferBalStudents[0].mealSchoolId) : '$'}</span>
                                                                            <input type="text"
                                                                                disabled={this.state.payTransferModalObject.studentWiseTransactions.length === 1}
                                                                                className="form-control"
                                                                                name="amount"
                                                                                value={this.state.payTransferModalObject.totalTransactionAmount}
                                                                                onKeyPress={(e) => { allowNumericWithdecimal(e) }}
                                                                                onKeyUp={(e) => { allowNumericWithdecimal(e) }}
                                                                                readOnly={true}
                                                                                onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                                                //  onChange={(e)=>{
                                                                                //   let payModel=  this.state.payTransferModalObject;
                                                                                //     if(e.target.value > this.state.primaryStudentData.accBalance){
                                                                                //         _addNotificationError("Insufficient amount.",this);
                                                                                //         return false;
                                                                                //     }
                                                                                //     payModel.studentWiseTransactions[ e.target.getAttribute('data-id')].transactionAmount=(e.target.value===''?0.00:e.target.value);
                                                                                //     payModel.totalTransactionAmount=parseFloat( (_.sum(_.map(payModel.studentWiseTransactions, d => parseFloat(d.transactionAmount)))).toFixed(2))
                                                                                //     this.setState({payModalObject:payModel});
                                                                                // }}
                                                                                placeholder="0.00" />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            <tfoot><tr>
                                                                <td></td>
                                                                <td>Transfer Amount :</td>
                                                                <td>{(Object.keys(this.state.transferBalStudents).length > 0) ? currency_symbol(this.state.transferBalStudents[0].mealSchoolId) + ' ' + (parseFloat(this.state.payTransferModalObject.totalTransactionAmount)) : 0.00}</td>
                                                            </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-right">
                                            <button type="button" className="btn btn-danger btn-xs"
                                                onClick={() => this.closePaymentTrnaferModel()}>
                                                <i className="fa fa-times-circle"
                                                    style={{ margin: '0 0 0 5px' }}></i> Cancel
                                            </button>
                                            <CustomSubmit id="payTrans" type="button" className="btn btn-success btn-xs"
                                                style={{
                                                    margin: '0'
                                                }}
                                                handleSubmit={(e, callback) => this.onSubmitPayment(e, callback)}
                                            >
                                                <i className="glyphicon glyphicon-ok"></i> Submit</CustomSubmit>

                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </Modal>


                    {/* <p className="text-center survey-link-text col-lg-12 col-md-12 col-xs-12 col-sm-12"><b>You may be
                        eligible for Free/Reduced lunch
                        program.
                        Take a quick <a style={{cursor: 'pointer'}}
                                        onClick={() => this.setState({modalIsOpen: true})}>survey</a> to find out.</b>                                       
                    </p>  */}
                </section>
            </div>
        );
    }
}


export default parentDashboard;


// WEBPACK FOOTER //
// ./src/components/Parent/Home/parentDashboard.jsx